import {formatDateForServer} from "@/plugins/moment";
import {IApp} from "@/interfaces/app.interface";
import {IAgentReport} from "@/modules/Report/interfaces/agent-report.interface";
import {IMovementsReport} from "@/modules/Report/Movements/interfaces/movements-report.interface";

export namespace IReport {
  export const Action = 'report';

  export enum ReportName {
    Balance = 'balance', // Общий баланс
    Events = 'events', // События
    Movement = 'movement', // Движение
    Cars = 'cars', // Сводная по машинам
    Parks = 'RptSvodParks', // Сводная по парковке
    CarsBalance = 'carsBalance2', // Баланс по машинам
    Agent = 'rptAgent', // Отчет агента
  }

  export const ReportTitle = {
    [ReportName.Movement]: 'Движение',
    [ReportName.Balance]: 'Общий баланс',
    [ReportName.Events]: 'События',
    [ReportName.Cars]: 'Сводная по машинам',
    [ReportName.CarsBalance]: 'Баланс по машинам',
    [ReportName.Parks]: 'Сводная по парковке',
    [ReportName.Agent]: 'Отчет агента',
  }

  export interface IState {
    loading: boolean;
    report: ReportType;
    previousReport: {
      name: null,
      list: ReportType,
    };
    tableTotal: ITableTotal;
    activeReport: ReportName,
    filters: IFilters;
    defaultFilters: IFilters;
    filtersLocal: IFiltersLocal;
    displayDetails: boolean;
    sortingTable: {
      prop: string;
      propType: IApp.SortingPropType;
      direction: IApp.SortDirection;
    };
    reportPayload: any;
  }

  export interface IFilters {
    corpId: number;
    corpName: string;
    str: string;
    dateBeg: string;
    dateEnd: string;
    balanceTypeId: number;
    parks: number[];
    payFlag: boolean;
    hours: number[];
    groupTypes: string[];
    cameras: number[];
    searchFlag?: boolean;
  }

  export const DefaultFilters = {
    corpId: null,
    corpName: '',
    str: '',
    dateBeg: '',
    dateEnd: '',
    balanceTypeId: null,
    parks: [],
    payFlag: false,
    hours: [],
    groupTypes: [],
    cameras: [],
    searchFlag: false,
  };

  export interface ITableTotal {
    limitCntRows: number;
    limitMessageFlag: boolean;
  }

  export interface IFiltersLocal {}

  export type ReportType = IBalanceItem[] | IEvent[] | IMovementsReport.IDataItem[] | ICars[] | ICarsBalance[] | IAgentReport.IDataItem[];
  export type ReportEntityType = IBalanceItem | IEvent | IMovementsReport.IDataItem | IMovementsReport.ICarPopupTableItemPrint | ICars | ICarsBalance | IAgentReport.IDataItem;

  export interface IBalanceItem {
    carCnt: number;
    corpCarCnt: number;
    corpName: string;
    corpPayType: string;
    id: number;
    lastSale: string;
    lastDatePay: string;
    payBank: number;
    payCard: number;
    payEqv: number;
    saldoBeg: number;
    saldoEnd: number;
    sale: number;
    finalScore?: boolean;
  }

  export interface IEvent {
    carId: number;
    number: number;
    carNumber: string;
    camCarNumber: string;
    comment: string;
    corpId: number;
    corpName: string;
    dateEvent: string;
    eventName: string;
    persName: string;
    hasPhoto?: boolean;
    finalScore?: boolean;
    intervalMinutes?: number;
  }

  export interface ICars {
    id: number;
    corpName: string;
    carNumber: string;
    persName: string;
    priceSum: number;
    tsum: number;
    discountSum: number;
    calcDiscount: number;
    nakopSum: number;
    paySum: number;
    hour: number;
    daysCn: number;
    hourAvg: number;
    corpPayType: string;
    lastSale: string;
    tarifNight: string;
    tarifWeekEnd: string;
    tarifDay: string;
    corpTarif: string;
    carId?: number;
    finalScore?: boolean;
  }

  export interface ICarsBalance {
    carId: number;
    carNumber: string;
    dateBeg: string;
    parkName: string;
    tSaldo: number;
    corpId: number;
    tSum: number;
    typeName: string;
    balanceTypeId: number;
    tSumPay?: number;
    persName?: string;
    finalScore?: boolean;
  }

  export enum IPropType {
    String = 'string',
    Number = 'number',
    Date = 'date',
    Actions = 'actions',
  }

  export interface ITableProp {
    label: string;
    prop: string;
    propType: IApp.SortingPropType;
    colspan?: number; // need for print tables.
    isMoney?: boolean;
    dateFormat?: string;
    useCustomDateFormat?: boolean;
    noPrint?: boolean;
    mobileHide?: boolean;
    actionClick?: any;
    actions?: ITableActionOptions[];
    usePrintedValue?: boolean;
    addClassFunction?: Function;
    noSorting?: boolean;
    customComponentName?: string;
  }

  export interface ITableActionOptions {
    tooltip?: string;
    icon?: string;
    text?: string;
    actionClick?: Function;
    disabled?: boolean;
  }

  export enum EmitterEvents {
    CLEAR_FILTERS = 'reports-filter:clear',
  }

  export enum LocalStorageKeys {
    ReportFilters = 'report-filters:form',
  }

  export function PrepareFilters(filters: IFilters) {
    let filtersToSend: any = {...filters};

    let dateInvalid = 'Invalid date';
    let dateProps = ['dateBeg', 'dateEnd'];
    dateProps.forEach(dateProp => {
      if (!!filters[dateProp] && filters[dateProp] !== dateInvalid) {
        filtersToSend[dateProp] = formatDateForServer(filters[dateProp], IApp.DateFormats.PrintedDate);
        if (filtersToSend[dateProp] === dateInvalid) {
          delete filtersToSend[dateProp];
        }
      }
    });

    let arrayKeys = ['parks', 'hours', 'cameras', 'groupTypes',];
    for (const key in filtersToSend) {
      if (arrayKeys.includes(key)) {
        if (!filtersToSend[key].length) delete filtersToSend[key];
      }
      else {
        if (!filtersToSend[key]) delete filtersToSend[key];
      }
    }
    return filtersToSend;
  }
}
